import styled from "styled-components";

export const Button = styled.button`
  position: relative;
  z-index: 1;
  outline: 3.5px solid;
  padding: 0.5em 1.25em;
  transition: background-color 300ms ease-out, color 300ms ease-out, outline-color 300ms ease-out;
  background-color: transparent;
  border-radius: 100px;
  border-width: 0;
  color: var(--wp--preset--color--blue-900);
  font-family: inherit;
  font-size: 1rem;
  font-weight: 700;
  line-height: inherit;
  text-decoration: none;
  cursor: pointer;
  width: 100%;
  outline-color: ${({color}) => {
    switch (color) {
      case 'yellow':
        return 'var(--wp--preset--color--yellow-400)'
      case 'blue':
        return 'var(--wp--preset--color--blue-400)'
      case 'orange':
      default:
        return 'var(--wp--preset--color--orange-400)'
    }
  }
  };

  &::before {
    background-color: ${({color}) => {
      switch (color) {
        case 'yellow':
          return 'var(--wp--preset--color--yellow-100)'
        case 'blue':
          return 'var(--wp--preset--color--blue-100)'
        case 'orange':
        default:
          return 'var(--wp--preset--color--orange-100)'
      }
    }
    };


    ${({type}) => type === 'primary' ? 'content:"";' : ''}
    position: absolute;
    top: -4px;
    left: -4px;
    width: calc(100% + 8px);
    height: calc(100% + 8px);
    border-radius: 100px;
    z-index: -1;
    transform: translate(6px, 8px);
    transition: transform 300ms ease-out;
  }

  @media screen and (hover: hover) {
    &:hover {
      &::before {
        transform: translate(0, 0);
      }

      ${({color, type}) => {
        if (type === 'primary') {
          return 'background-color:transparent;';
        }
        switch (color) {
          case 'yellow':
            return 'background-color: var(--wp--preset--color--yellow-400);'
          case 'blue':
            return 'background-color: var(--wp--preset--color--blue-400);'
          case 'orange':
          default:
            return 'background-color: var(--wp--preset--color--orange-400);'
        }
      }
      }
      ${({color, type}) => {
        if (type === 'primary') {
          return ''
        }
        switch (color) {
          case 'yellow':
            return 'outline-color: var(--wp--preset--color--yellow-400);'
          case 'blue':
            return 'outline-color: var(--wp--preset--color--blue-400);'
          case 'orange':
          default:
            return 'outline-color: var(--wp--preset--color--orange-400);'
        }
      }
      }
      ${({color, type}) => {
        if (type === 'primary') {
          return ''
        }
        switch (color) {
          case 'yellow':
            return 'color: var(--wp--preset--color--blue-900);'
          case 'orange':
          case 'blue':
          default:
            return 'color: var(--wp--preset--color--white-shade);'
        }
      }
      }
    }
  }
`;